export const CART_LINK = 'https://templodigital.shop/cart/42807137337415:1'
